import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Image, Typography } from 'tfc-components';

import banking from 'assets/images/home/use_case_banking.png';
import ecomerce from 'assets/images/home/use_case_ecomerce.png';
import education from 'assets/images/home/use_case_education.png';
import government from 'assets/images/home/use_case_government.png';
import stars from 'assets/images/home/use_case_stars.png';
import Section from 'components/organisms/Section';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';

const data = [
  {
    id: 1,
    title: 'Ecommerce',
    imageUrl: ecomerce,
  },
  {
    id: 2,
    title: 'Education',
    imageUrl: education,
  },
  {
    id: 3,
    title: 'Banking',
    imageUrl: banking,
  },
  {
    id: 4,
    title: 'Government Services',
    imageUrl: government,
  },
];

interface IUseCaseItem {
  item: {
    title: string;
    imageUrl: string;
  };
}

const UseCaseItem = ({ item }: IUseCaseItem) => (
  <div className="p-home_useCase_item">
    <div className="p-home_useCase_itemWrap">
      <Typography.Text fontweight="600" extendClasses="fs-24x30">
        {item.title}
      </Typography.Text>
      <div className="p-home_useCase_itemImage">
        <Image extendClasses="p-home_useCase_image" imgSrc={item.imageUrl} alt="Google" ratio={1} />
      </div>
    </div>
  </div>
);

const UseCaseSection: React.FC = () => {
  const systemOthers = useAppSelector((state: RootState) => state.system.system);

  const navigate = useNavigate();
  return (
    <Section className="p-home_useCase">
      <Section.Title sectionName="Blog">
        Ask2Auto across industries
      </Section.Title>
      <Typography.Text textStyle="center" extendClasses="p-home_useCase_description fs-20x24">
        See how Ask2Auto works by industry
      </Typography.Text>
      <div className="p-home_useCase_center">
        <Button onClick={() => navigate(`/${systemOthers?.slugPages?.blog || '404'}`)} variant="primary" extendClasses="p-home_useCase_button f-16x24">
          View more
        </Button>
      </div>
      <div className="p-home_useCase_content">
        <div className="p-home_useCase_group">
          {data.map((item) => (
            <UseCaseItem key={item.id} item={item} />
          ))}
        </div>
      </div>
      <div className="p-home_useCase_starsWrap">
        <Image extendClasses="p-home_useCase_stars" imgSrc={stars} alt="Stars" ratio={1} />
      </div>
    </Section>
  );
};

export default UseCaseSection;
